import { getState } from './state';
import { createSelector } from 'reselect';

export const getViewOptions = createSelector(
  [getState],
  state => state.viewOptions ?? {}
);

export const getActiveBucket = createSelector(
  [getViewOptions],
  viewOptions => viewOptions.activeBucket
);

export const getIsCategoryFilterApplied = createSelector(
  [getActiveBucket],
  activeBucket => activeBucket?.filterId !== undefined
);

export const getActiveFolder = createSelector(
  [getViewOptions],
  viewOptions => viewOptions.activeFolder
);

export const getShowShortcuts = createSelector(
  [getViewOptions],
  viewOptions => viewOptions.showShortcuts
);
